const newContextUIModule = {
  namespaced: true,
  modules: {},
  state: () => ({
    setup: {
      workspaceId: null,
      parentFolderId: null
    },
    newContextId: null
  }),
  getters: {},
  mutations: {
    SET_NEWCONTEXT_STATE(state, { key, subkey, value }) {
      if (subkey) {
        state[key][subkey] = value;
      } else {
        state[key] = value;
      }
    },
    clearState(state) {
      state.setup = { workspaceId: null, parentFolderId: null };
      state.newContextId = null;
    }
  }
};

export default newContextUIModule;
